import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageResponse, Pageable, Sortable } from '@app/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Role } from './role';

export interface RolesQueryParams {
  name?: string;
  linesPerPage?: number;
  page?: number;
  orderBy?: string;
  direction?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private readonly baseUrl = `${environment.accountUrl}/api/v1/roles`;

  constructor(private http: HttpClient) {}

  public listRoles(params?: RolesQueryParams): Observable<PageResponse<Role>> {
    const { name, linesPerPage, page, orderBy, direction } = params || {};
    const httpParams = new HttpParams({
      fromObject: {
        name: name ?? '',
        linesPerPage: (linesPerPage ?? 10).toString(),
        page: (page ?? 0).toString(),
        orderBy: orderBy ?? 'name',
        direction: direction ?? 'ASC',
      },
    });

    return this.http
      .get<AccountRolesResponse>(this.baseUrl, {
        params: httpParams,
      })
      .pipe(map(response => this.mapToPageResponse(response, params)));
  }

  private mapToPageResponse(
    response: AccountRolesResponse,
    params?: RolesQueryParams
  ): PageResponse<Role> {
    const page = params?.page ?? 0;
    const pageSize = params?.linesPerPage ?? 10;
    const totalPages = response.totalPages ?? 1;
    const totalElements =
      response.totalElements ?? response.items?.length ?? 0;
    const content = response.items ?? [];
    const sort: Sortable = {
      sorted: !!params?.orderBy,
      unsorted: !params?.orderBy,
    };
    const pageable: Pageable = {
      offset: page * pageSize,
      pageSize,
      pageNumber: page,
      unpaged: false,
      paged: true,
      sort,
    };

    return {
      content,
      totalElements,
      totalPages,
      last: page >= totalPages - 1,
      number: page,
      size: pageSize,
      sort,
      numberOfElements: content.length,
      first: page === 0,
      pageable,
    };
  }
}

interface AccountRolesResponse {
  items: Role[];
  totalElements?: number;
  totalPages?: number;
}

